<template>
<div class="inputNumber">
    <div class="el-j" @click="handleDown" :class="{disabled:currentValue <= min}"><i class="iconfont icon-jian1"></i></div>
    <div class="el-i">
        <input type="tel" autocomplete="off" max="10" min="1" :maxlength="maxlength" :value="currentValue" @change="handleChange" class="el-input_inner">
    </div>
    <div  @click="handleUp" :class="{disabled:currentValue >= max}" class="el-p"><i class="iconfont icon-jia1"></i></div>
    </div>
</template>
<script>
export default {
  props: {
    max: {
      //必须是数字类型
      type: Number,
      //默认值为Infinity
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    maxlength: {
      type: Number,
      default: 3
    },
    value: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  mounted() {
    this.updateValue(this.value);
  },
  methods: {
    //父组件传递过来的值可能不符合条件（大于最大值，小于最小值）
    updateValue(val) {
      if (val > this.max) {
        val = this.max;
      }
      if (val < this.min) {
        val = this.min;
      }
      this.currentValue = val;
    },
    handleDown() {
      this.currentValue -= this.step;
      if (this.currentValue <= this.min) {
        this.currentValue = this.min;
      }
    },
    handleUp() {
      this.currentValue += this.step;
      if (this.currentValue >= this.max) {
        this.currentValue = this.max;
      }
    },
    getValue() {
      return this.currentValue;
    },
    isValueNumber(val) {
      if (val === "" || val == null) {
        return false;
      }
      return !isNaN(val);
    },
    handleChange(event) {
      var val = event.target.value.trim();
      var max = this.max;
      var min = this.min;
      if (this.isValueNumber(val)) {
        val = Number(val);
        this.currentValue = val;
        if (val > max) {
          this.current = max;
        }
        if (val < min) {
          this.current = min;
        }
      } else {
        //如果输入的不是数字，将输入的内容重置为之前的currentValue
        event.target.value = this.currentValue;
      }
    }
  },
  watch: {
    currentValue: function(val) {
      //$emit与父组件通信  （子组件-->父组件）
      //this指向当前组件实例
      this.$emit("input", val);
      // //定义自定义函数进行通信
      // this.$emit("on-change", val);
    }
  }
};
</script>
<style lang='less'>
.inputNumber {
  position: relative;
  width: 4.2rem;
   border: 1px solid #e8e8e8;
   border-radius: 2px;
    height: .83rem;
  .disabled {
    .iconfont {
      color: #c0c4cc !important;
    }
  }
  .el-j .iconfont {
    font-size: 14px;
    color: #666;
  }
  .el-p .iconfont {
    font-size: 12px;
    color: #666;
  }
  .el-j,
  .el-p,.el-i {
    position: absolute;
    left: 0;
    top: 0;
    width: 1.17rem;
    height: 100%;
    line-height: .83rem;

    text-align: center;
    background: #f5f7fa;
    color: #606266;
    font-size: 13px;
  }
  .el-j{ border-right: 1px solid #e8e8e8;}
  .el-p{ border-left: 1px solid #e8e8e8;}
  .el-p {
    left: 3rem;
  }
  .el-i {
    left: 1.2rem;
    width:1.8rem;
  }
  .el-input_inner {
    border:0;
    color: #606266;
    height: 96%;
    -webkit-appearance: none;
    outline: 0;
    margin: 0;
    width:100%;
    line-height:.8rem;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// inputNumber.vue?0ba0dba8